import { Container } from "@mui/material";
import { styled } from "@mui/system";

export const StyledWrapper = styled(Container)(({ theme }) => ({
  width: "100%",
  maxWidth: "100% !important",
  paddingLeft: "16px !important",
  paddingRight: "16px !important",
  boxSizing: "border-box",
  ".logo-holder": {
    width: "126px",
    display: "flex",
    alignItems: "center",
    "& img": {
      width: "100%",
    },
  },
  ".icon-holder": {
    display: "flex",
    justifyContent: "flex-end",
    transition: "none",
    flexGrow: 1,
  },
  ".icon-button": {
    padding: "8px",
    "&:hover": {
      backgroundColor: "transparent",
    },
    ".icon": {
      width: "24px",
      height: "24px",
      color: theme.palette.white.main,
    },
  },
}));
